export default __webpack_public_path__ + "static/media/2019-7.a672081c.jpeg";